import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortIpUtil'
})
export class SortIpUtilPipe implements PipeTransform {

  transform(value: string[]): string[] {
    let ipv4: string[] = [];
    let ipv6: string[] = [];

    value.forEach(ip => {
      if (ip.indexOf(".") > 0) {
        ipv4.push(ip);
      }else{
        ipv6.push(ip);
      }
    });

    return ipv4.concat(ipv6);
  }

}
